import { get, post } from './http';

const baseUrl = process.env.VUE_APP_BASE_URL;

// 上传文档用于生成大纲
const uploadFile = (data) => post(`${baseUrl}/upload/documentForOutline`, data);

export default {
  uploadFile,
};
